import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, addDoc, collection, serverTimestamp } from 'firebase/firestore';
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import '../components/styles.css';

const KontakPage = () => {
  const [settings, setSettings] = useState({
    address: 'Memuat alamat...',
    contactPhone: 'Memuat nomor telepon...',
    contactPhone2: '',
    contactEmail: 'Memuat email...',
    googleMapsUrl: '',
  });
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ message: '', type: '' });

  useEffect(() => {
    const fetchSettings = async () => {
      const docRef = doc(db, "settings", "siteConfig");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setSettings(docSnap.data());
      } else {
        console.log("No site settings found!");
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setSubmitStatus({ message: 'Harap isi semua kolom.', type: 'error' });
      return;
    }
    setSubmitting(true);
    setSubmitStatus({ message: '', type: '' });
    try {
      await addDoc(collection(db, 'pesanKontak'), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      setSubmitStatus({ message: 'Pesan Anda berhasil terkirim!', type: 'success' });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error("Error sending message: ", error);
      setSubmitStatus({ message: 'Gagal mengirim pesan. Silakan coba lagi.', type: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <SEO 
        title="Hubungi Kami - SMK Pariwisata Sumbangsih" 
        description="Informasi kontak, alamat lokasi, nomor telepon, dan formulir pesan untuk menghubungi SMK Pariwisata Sumbangsih." 
      />
      <PageHeader title="Hubungi Kami" subtitle="Kami siap membantu Anda. Jangan ragu untuk menghubungi kami." />
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <div className="kontak-grid">
              <div className="kontak-info-container">
                <h3>Informasi Kontak</h3>
                <p>Silakan hubungi kami melalui detail di bawah ini atau gunakan formulir kontak di samping. Kami akan merespons sesegera mungkin.</p>
                <ul className="kontak-info-list">
                  <li><FaMapMarkerAlt /> <div>{settings.address}</div></li><li><FaPhone /> <div><a href={`tel:${settings.contactPhone}`}>{settings.contactPhone}</a></div></li>
                  {settings.contactPhone2 && <li><FaPhone /> <div><a href={`tel:${settings.contactPhone2}`}>{settings.contactPhone2}</a></div></li>}<li><FaEnvelope /> <div><a href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a></div></li>
                </ul>
                <div className="map-container" style={{ borderRadius: 'var(--border-radius)', overflow: 'hidden', marginTop: '30px' }}>
                  {settings.googleMapsUrl && <iframe src={settings.googleMapsUrl} width="100%" height="300" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Lokasi Sekolah"></iframe>}
                </div>
              </div>
              <div className="kontak-form-container">
                <h3>Kirim Pesan</h3>
                <form onSubmit={handleSubmit} className="kontak-form">
                  <div className="form-group"><input type="text" name="name" placeholder="Nama Anda" value={formData.name} onChange={handleChange} required /></div>
                  <div className="form-group"><input type="email" name="email" placeholder="Email Anda" value={formData.email} onChange={handleChange} required /></div>
                  <div className="form-group"><input type="text" name="subject" placeholder="Subjek" value={formData.subject} onChange={handleChange} required /></div>
                  <div className="form-group"><textarea name="message" rows="6" placeholder="Pesan Anda" value={formData.message} onChange={handleChange} required></textarea></div>
                  <button type="submit" className="btn-hero" disabled={submitting}>{submitting ? 'Mengirim...' : 'Kirim Pesan'}</button>
                  {submitStatus.message && <p style={{ marginTop: '15px', color: submitStatus.type === 'error' ? 'red' : 'green' }}>{submitStatus.message}</p>}
                </form>
              </div>
            </div>
          </div>
        </section>
      </AnimatedSection>
    </>
  );
};

export default KontakPage;